import { useTranslate } from '@refinedev/core';
import { Card, Table, Tag } from 'antd';
import type { ElibriSyncEventOut } from '@/api/generated/schemas';

interface DistributionPeriodElibriEventsTableProps {
  events: ElibriSyncEventOut[];
}

export const DistributionPeriodElibriEventsTable = ({
  events,
}: DistributionPeriodElibriEventsTableProps) => {
  const t = useTranslate();

  return (
    <Card title={t('content_catalog.distribution_periods.tabs.elibri_events')}>
      <Table<ElibriSyncEventOut>
        dataSource={events}
        rowKey="id"
        size="small"
        pagination={false}
        locale={{ emptyText: t('messages.no_data') }}
        expandable={{
          expandedRowRender: (event) => (
            <pre
              style={{
                margin: 0,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
              }}
            >
              {JSON.stringify(event.payload, null, 2)}
            </pre>
          ),
        }}
      >
        <Table.Column dataIndex="id" title={t('base.fields.id')} />
        <Table.Column
          dataIndex="event_type"
          title={t('content_catalog.distribution_periods.fields.event_type')}
          render={(value: string) => <Tag>{value}</Tag>}
        />
        <Table.Column
          dataIndex="created_at"
          title={t('base.fields.created_at')}
          render={(value: string | null) =>
            value ? new Date(value).toLocaleString() : '-'
          }
        />
      </Table>
    </Card>
  );
};
